import React from 'react'

type Props = {
  link: string
  title: string
}

const IFrame: React.FC<Props> = ({link, title}) => {
  return (
    <iframe
      height="0"
      src={`${link}?v=${Date.now()}`}
      style={{
        display: 'none',
        visibility: 'hidden',
      }}
      title={title}
      width="0"
    />
  )
}

export default IFrame
